jQuery( document ).ready(function() {

    /**
     * Setea la cookie
     * @param name
     * @param value
     * @param days
     */
    function setCookie(nombre,valor,horas) {
        var expires = "";
        if (horas) {
            var date = new Date();
            date.setTime(Date.now() + (horas*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = nombre + "=" + (valor || "")  + expires + "; path=/";
    }

    /**
     * Obtiene la cookie
     * @param name
     * @returns {*}
     */
    function obtenerCookie(nombre) {
        var nameEQ = nombre + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    /**
     * Borra la cookie
     * @param name
     */
    function borrarCookie(nombre) {
        document.cookie = nombre+'=; Max-Age=-99999999;';
    }


    var codigo_descuento = obtenerCookie('discount_code');
    var estado_promocion = '';

    if(obtenerCookie('discount_code_estado') != null){
        estado_promocion = obtenerCookie('discount_code_estado');
    }
    if(codigo_descuento != null) {
        var elemento = jQuery('#promocion-holalfy');
        var numero = codigo_descuento.match(/\d/g);
        var texto = '';
        if(numero == '5'){
            texto = '<p class="titulo-promo">🎉 Disfrutas de un ' + numero + '% de descuento con el código ' + codigo_descuento + ' 🎉</p>';
        }else{
            texto = '<p class="titulo-promo">🎉 Disfrutas de un descuento con el código ' + codigo_descuento + ' 🎉</p>';
        }
        var mensaje = '<div class="promos-shopify ' + estado_promocion + '">' +
            '<span class="cerrar-promo">x</span>' +
            texto +
            '<p class="subtitulo-promo">Se aplicará de forma automática al introducir tus datos de envío</p>' +
        '</div>'
        elemento.append(mensaje);

        elemento.children('.promos-shopify').show();
    }


    jQuery('.cerrar-promo').on('click', function () {
       setCookie('discount_code_estado','oculto', 3);
        jQuery('.promos-shopify').addClass('oculto')
    });


});